<template>
  <div>
    <v-card-title class="headline primary" primary-title dark>
      {{ alertTitle }}
    </v-card-title>

    <v-card-text>
      {{ alertMessage }}
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn v-if="display" color="primary" flat @click="$emit('display')">
        {{ $t('button.display') }}
      </v-btn>
      <v-btn color="primary" flat @click="$emit('close')">
        {{ $t('button.close') }}
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
export default {
  props: {
    alertTitle: {
      type: String,
      required: true,
    },
    alertMessage: {
      type: String,
      required: true,
    },
    display: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.v-card__title {
  color: white;
}
</style>
